import SendbirdChat from '@sendbird/chat';
import { GroupChannelModule } from '@sendbird/chat/groupChannel';

import { isServer } from '../../utils/constants';

const appId = process.env.NEXT_PUBLIC_SENDBIRD_APP_ID ?? '';
if (!appId) {
  throw new Error('NEXT_PUBLIC_SENDBIRD_APP_ID is not set');
}

export const sendbirdClient = isServer
  ? null
  : SendbirdChat.init({
      appId,
      modules: [new GroupChannelModule()],
    });
